export const paymentApproval=`<p>You must have the relevant entitlements in place for Payment Approval in order to approve or reject payments, as covered in <a href='javascript:void(0)' data-link='roleProfilesUsersSetup'>Role Profiles and Users</a> section .
</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/17/1.png' /></p>
<p>Payment approvals are made by via <strong>Approvals &gt; </strong><strong>Pending Approvals</strong> and selecting the <strong>T</strong><strong>ransactions </strong>category. &nbsp;In this section you will have the option of selecting an Action to approve, hold or reject the payment.</p>
<p>If you wish to approve multiple payments at the same time then select &lsquo;Approve&rsquo; and &lsquo;Apply to all&rsquo; from the Approvals action drop down list and then click on <strong>Submit</strong>.</p>
<p>Note: the Apply to all applies to all payments on that page (20 transactions), not every payment waiting for approval.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/17/2.png' /></p>
<p>Or you can approve one transaction at a time.  Scroll to the right hand side of the screen and you will see the hold, approve and reject options. Select one of these and click Submit.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/17/3.png' /></p>
<p><img src='${process.env.PUBLIC_URL}/images/4/17/4.png' /></p>
<p>Next you'll need your security card and card reader. Follow the steps on screen to complete the approval.  When the approval is complete, you will see a confirmation message at the top of the screen.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/17/5.png' /></p>

<p>If a payment has FX, the payment approver will have to set the FX rate during the approval process.&nbsp; This is done by clicking on &ldquo;Get rate&rdquo; and you have 1 minute to approve the rate you are offered.&nbsp; This is explained in more detail in the international payments section.</p>
<p>For a future dated FX payment, the approver has 2 steps to take:&nbsp;</p>
<ol>
<li>Approve the payment, at which point the payment is warehoused until the future date.</li>
<li>On the future execution date, the payment will reappear in the &lsquo;Pending Approvals &gt; FX &rsquo; tab at which point any of the users in the payment approval workflow can approve the FX when the payment is released for processing from the warehouse.</li>
If a payment creator creates a future dated FX payment for tomorrow, but creates it after cut off period for the day, the approver approves on the day of creation. Therefore when they go to approve they do the 2 steps above in one &ndash; approve the payment and purchase the FX rate. Timings of the cut off mean the payment is being processed as if it is same day.&nbsp;</p>

</ol>

 
<p><strong>Approved Payment Status</strong></p>
<p>In the Approved Payments section of the Payments Summary screen, each payment will display a status. A list of these statuses can be found in <em>Payment Summary</em> section.</p>
<p><strong>Display who has approved a payment</strong></p>
<p>If you want to see if a payment has been approved, you can look for the approvers in Payments / Payment summary / pending payments and Approvals / pending approvals / Transactions.</p>
<p>If none of the approvers in the workflow have approved a payment, the pending approval displays will include a label of "<strong>Approved by</strong>" with no name next to it.  This makes it clear that none of the approvers have approved the payment yet.</p>
<p>When a payment has an approval chain and has been approved by one user, then this user is displayed in the "Approved by" section of the screen.</p>
<p>When a payment has an approval chain and has been approved by two users then both approvers are shown in the "Approved by" section. The approvers will be listed in the order in which they approved the payment.</p>
<p>When all the approvals in the workflow are completed, there is no longer a display of who has approved the payment.  The approved payment can be viewed in Payments/Payment Summary/Approved payments.</p>
<p><strong>Approvals / Pending approvals / Transactions</strong></p>
<p><img src='${process.env.PUBLIC_URL}/images/4/17/6.png' /></p>
<p><strong>
Payment Summary, Pending payments</strong></p>
<p><img src='${process.env.PUBLIC_URL}/images/4/17/7.png' /></p>
<p>The following table explains the approvals display.</p>
<table class='table table-bordered' >
<tbody>
<tr>
<td width="367">
<p align="center"><strong>Scenario</strong></p>
</td>
<td  width="200">
<p align="center"><strong>Approval Chain Users#</strong></p>
</td>
<td width="267">
<p align="center"><strong>Payment Summary - Pending </strong></p>
</td>
<td width="190">
<p align="center"><strong>Approvals</strong></p>
</td>
</tr>
<tr>
<td width="367">
<p>Payment created and in pending approval state - <strong>Not yet approved</strong> </p>
</td>
<td  width="200">
<p align="center">1</p>
</td>
<td width="267">
<p>No Approvers</p>
</td>
<td width="150">
<p>No Approvers</p>
</td>
</tr>
<tr>
<td width="367">
<p>Payment created, in Approved state - <strong>Approved by one user</strong> </p>
</td>
<td  width="200">
<p align="center">1</p>
</td>
<td width="267">
<p>Payment is approved and no longer shown</p>
</td>
<td width="150">
<p>No Longer present</p>
</td>
</tr>
<tr>
<td width="367">
<p>Payment created and in pending approval state - <strong>Not yet approved</strong> </p>
</td>
<td  width="200">
<p align="center">2</p>
</td>
<td width="267">
<p>No Approvers</p>
</td>
<td width="150">
<p>No Approvers</p>
</td>
</tr>
<tr>
<td width="367">
<p>Payment created, in pending approval state  - <strong>Approved by one user</strong> </p>
</td>
<td  width="200">
<p align="center">2</p>
</td>
<td width="267">
<p>1 Approver shown</p>
</td>
<td width="150">
<p>1 Approver shown</p>
</td>
</tr>
<tr>
<td width="367">
<p>Payment created, in and in approved state  - <strong>Approved by two users</strong></p>
</td>
<td  width="200">
<p align="center">2</p>
</td>
<td width="267">
<p>Payment is approved and no longer shown</p>
</td>
<td width="150">
<p>No Longer present</p>
</td>
</tr>
<td width="367">
<p>Payment created and in pending approval state  - <strong>Not yet approved</strong></p>
</td>
<td  width="200">
<p align="center">3</p>
</td>
<td width="267">
<p>No Approver</p>
</td>
<td width="150">
<p>No Approver</p>
</td>
</tr>
<tr>
<td width="367">
<p>Payment created, in pending approval state - <strong>Approved by 1 user</strong></p>
</td>
<td  width="200">
<p align="center">3</p>
</td>
<td width="267">
<p>1 Approver shown</p>
</td>
<td width="150">
<p>1 Approver shown</p>
</td>
</tr>
<tr>
<td width="367">
<p>Payment created, in and in approved state - <strong>Approved by two users</strong></p>
</td>
<td  width="200">
<p align="center">3</p>
</td>
<td width="267">
<p>2 Approvers shown</p>
</td>
<td width="150">
<p>2 Approvers shown</p>
</td>
</tr>
<tr>
<td width="367">
<p>Payment created, in and in approved state - <strong>Approved by three users</strong></p>
</td>
<td  width="200">
<p align="center">3</p>
</td>
<td width="267">
<p>Payment is approved and no longer shown</p>
</td>
<td width="150">
<p>No Longer present</p>
</td>
</tr>

</tbody>
</table>


`;


// WEBPACK FOOTER //
// ./src/components/content/payments/17-paymentApprovals.ts